export default __webpack_public_path__ + "static/media/Identify-Risk-supply-chain.9ea241d0.svg";